module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_1.7c85a144.png";